<template>
    <div class="d-flex flex-wrap align-items-center gap-2 w-100">
      <div class="d-flex flex-wrap align-items-center me-auto mb-2 mb-md-0">
        <Button v-if="$can(abilities.TASK_PROJECT_CREATE)" btn-class="btn-sm me-3" type="new" id="new_btn" btn-text="button.create" size="7px 30px" @click="createNewTask" ></Button>
<!--         <OutlineButton btn-class="btn-sm mx-3" icon-class="fas fa-download" type="primary" :border="true" id="submit_btn" btn-text="contacts.export" @click="exportTaskFile" :isLoading="isLoading"></OutlineButton>
 -->        <div class="bg-white shadow justify-content-center align-items-center px-1 me-3 rounded-2">
          <a @click="changeModelViewType(modelViewType.kanban)"
            :class="route.query.viewType === modelViewType.kanban ? 'active' : ''"
            class="btn btn-sm btn-outline-primary text-active-white text-hover-white btn-icon me-1"
            :title="$t('tasks.kanban')"
          >
            <i class="bi bi-grid-fill fs-4 text-primary"></i>
          </a>
          <a @click="changeModelViewType(modelViewType.list)"
            :class="route.query.viewType === modelViewType.list ? 'active' : ''"
            class="btn btn-sm btn-outline-primary text-active-white text-hover-white btn-icon"
            :title="$t('tasks.list')"
          >
            <i class="bi bi-list-task fs-4 text-primary"></i>
          </a>
          
        </div>
      </div>
  
      <div class="d-flex align-items-center mt-2 mt-md-0">
        <Input
            v-if="showSearch"
            container-class="me-2"
            size="sm"
            inputClass="form-control form-control-sm"
            name="input-search"
            :isInputGroup="true"
            :placeholder="$t('label.search')"
            v-model="query.search"
        >
          <template #rightAddon>
            <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle">
              <i class="fa fa-search"></i>
            </span>
          </template>
        </Input>

        <ButtonDropdownFilter
            :btn-title="$t('label.priority')"
            :options="[...priorities]"
            value-field="id"
            name-field="title"
            v-model="query.priority"
        />
<!--       <ButtonDropdownFilter-->
<!--            :btn-title="$t('label.status')"-->
<!--            :options="[...milestones]"-->
<!--            value-field="id"-->
<!--            name-field="title"-->
<!--            v-model="query.milestone"-->
<!--        />-->
        <DateRangePicker v-if="false" :id="id" @update:date="handleRangeDate" />

      </div>
    </div>
    <NewTaskModal id="create_new_task" :form="formData" @reloadData="reload"/>

  </template>
  <script setup>
  import Input from "@/components/Input.vue";
  import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
  import {useModelViewType} from "@/composables/modelViewType";
  import {computed, onMounted, ref, watch} from "vue";
  import {useStore} from "vuex";
  import {useRoute, useRouter} from "vue-router";
  import Button from "@/components/Button";
  import {useLocales} from "@/composables/locales";
  import OutlineButton from "@/components/OutlineButton";
  import DateRangePicker from "@/components/DateRangePicker.vue";
  import abilities from "@/composables/abilities";
  import NewTaskModal from "./Modals/Task/NewTaskModal.vue";
  
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const { modelViewType } = useModelViewType()
  
  const { locale } = useLocales()

  const formData = ref({
    title: "",
    project_id: "",
    project_category_step_id: "",
    task_status_id: "",
    task_priority_id: "",
    description: "",
    users: [],
  })
  
  const props = defineProps({
    handleRangeDate: {type: Function, default: () => {}},
    query: {type: Object, default: {startDate: '',endDate: '',search: '',status: '',priority: '', milestone: ''}},
    showSearch: {type: Boolean, default: true}
  })
  
  const isLoading = ref(false)
  
  const query = ref(props.query)

  const priorities = computed(() => store.getters['taskPriorities/getTaskPriorities'])
  const milestones = computed(() => store.getters['projectSteps/getProjectSteps'])


  
  function changeModelViewType (viewType) {
    router.push({ query: { viewType , tab: "kt_tasks"} });
  }
  
  async function exportTaskFile(){
    try {
      isLoading.value = true
      await store.dispatch('pipelines/exportPipeline')
    } catch (e) { }
    isLoading.value = false
  }
  
  function goToStatistic(){
    router.push({name: 'pipelines-chart'})
  }
  
  function createNewTask (){
    $('#create_new_task').modal('toggle')
    formData.value = null
    formData.value = {
      title: "",
      project_id: "",
      project_category_step_id: props.query.milestone,
      task_status_id: "",
      task_priority_id: "",
      description: "",
      users: []
    }
  }

  function reload(){
    query.value.status = Math.random()?.toString()
  }
  </script>
  <style scoped>
  @import "@eonasdan/tempus-dominus/dist/css/tempus-dominus.min.css";
  
  
  </style>
  